module.exports = __webpack_public_path__ + "static/img/file_html.954a58fb.png";